const webMobile = [
  { id: 1, name: "React", image: "svg/react-logo.svg" },
  { id: 2, name: "React Native", image: "svg/reactnative-logo.svg" },
  { id: 3, name: "Node.js", image: "svg/node-logo.svg" },
  { id: 4, name: "SpringBoot", image: "svg/spring-logo.svg" },
  { id: 5, name: "PostgreSQL", image: "svg/postgresql-logo.svg" },
  { id: 6, name: "MySQL", image: "svg/mysql-logo.svg" },
  { id: 7, name: "Tailwind", image: "svg/tailwind-logo.svg" },
  { id: 8, name: "Express.js", image: "svg/express-logo.svg" },
  { id: 9, name: "TypeScript", image: "svg/ts-logo.svg" },
  { id: 10, name: "PHP", image: "svg/php-logo.svg" },
  { id: 11, name: "Wordpress", image: "svg/wp-logo.svg" },
  { id: 12, name: "MongoDB", image: "svg/mongo-logo.svg" },
];

export default webMobile;
